import { TIME_SHEET_TIMER, TIMER_START, PLAY_START } from '../actionTypes';

const initialState = {
    time: {
        sec: 0,
        min: 0,
        hr: 0
    },
    isStart: null,
    isPlay: false,
};

const timeSheetReducer = (state = initialState, action) => {
    switch (action.type) {
        case TIME_SHEET_TIMER:
            return {
                ...state, time: action.payload
            };
        case TIMER_START:
            return {
                ...state, isStart: action.payload
            };
        case PLAY_START:
            return {
                ...state, isPlay: action.payload
            };
        default:
            break;
    }

    return state;
};

export default timeSheetReducer;
